import EntitiesView from 'Components/EntitiesView';
import { actions } from 'ducks/organizations';
import React from 'react';
import { connect } from 'react-redux';
import columns from 'utils/columns/organizations';
import Edit from './Edit';
import New from './New';
import Show from './Show';

const Component = props => {
    const { superuser } = props.currentUser;

    return (
        <EntitiesView
            columns={columns}
            editComponent={superuser ? Edit : null}
            newComponent={superuser ? New : null}
            showComponent={Show}
            {...props}
        />
    );
};

const mapStateToProps = state => {
    const { allChecked, checked, ids, models, loading, searching, searchValue, sortBy, sortDirection } = state.organizations;

    return {
        allChecked, checked, ids, models, loading, searching, searchValue, sortBy, sortDirection,
        currentUser: state.users.models[state.auth.currentUserId]
    };
};

const { changeSearch, changeSort, fetchAll, toggleAll, toggleOne } = actions;

const mapDispatchToProps = ({
    changeSearch,
    changeSort,
    fetchData: fetchAll,
    toggleAll,
    toggleOne: event => {
        event.stopPropagation();
        return toggleOne(event.target.name);
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
